import React from "react";
import { DollarOutlined, FileTextOutlined, UserOutlined } from "@ant-design/icons";
import FinanceExpenseQueue from "./Pages/FinanceDashboard/FinanceExpenseQueue";
import FinancePayments from "./Pages/FinanceDashboard/FinancePayments";
import FinanceProfile from "./Pages/FinanceDashboard/FinanceProfile";

// Finance actor sidebar + routes (Points 7 & 8). Rendered only when the
// logged-in user's role is "Finance" (see App.js getAccessibleRoutes).
const financeRoutes = [
  {
    type: "collapse",
    name: "Work Queue",
    key: "finance-queue",
    route: "/financedashboard",
    icon: <DollarOutlined size="16px" />,
    component: <FinanceExpenseQueue />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Paid Expenses",
    key: "finance-payments",
    route: "/financedashboard/payments",
    icon: <FileTextOutlined size="16px" />,
    component: <FinancePayments />,
    noCollapse: true,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "finance-profile",
    route: "/financedashboard/profile",
    icon: <UserOutlined size="16px" />,
    component: <FinanceProfile />,
    noCollapse: true,
  },
];

export default financeRoutes;
